import {
  put,
  call,
  takeLatest,
  takeEvery
} from 'redux-saga/effects';
import {
  OUTLETS_FETCH_ALL,
  OUTLETS_UPDATE,
  OUTLETS_ADD,
  OUTLETS_DELETE
} from './constants';
import {
  fetchOutletsSuccess,
  fetchOutletsFail,
  addOutletFail,
  addOutletSucccess,
  updateOutletSuccess,
  updateOutletFail,
  deleteOutletSuccess,
  deleteOutletFail
} from './actions';
import { parseApiError } from '../util/api';
import OutletsAPI from './OutletsAPI';
import { showNotification } from '../notifications/actions';

function *fetchOutlets () {
  try {
    const { data } = yield call(OutletsAPI.fetchOutlets);
    if (data && Array.isArray(data.salesOutlets)) {
      yield put(fetchOutletsSuccess(data.salesOutlets));
    } else {
      let msg = 'unexpected response fetching outlets';
      yield put(fetchOutletsFail(msg));
      yield put(showNotification(
        'Failed to load outlets', msg, 'error', 10
      ));
    }
  } catch (error) {
    const msg = parseApiError(error);
    yield put(fetchOutletsFail(msg));
    yield put(showNotification(
      'Failed to load outlets', msg, 'error', 10
    ));
  }
}

function *addOutlet (action) {
  try {
    yield call(OutletsAPI.addOutlet, action.outlet);
    yield put(addOutletSucccess(action.outlet));
    yield put(showNotification(
      'Success', `${action.outlet.name} saved`, 'info', 5
    ));
  } catch (error) {
    const msg = parseApiError(error);
    yield put(addOutletFail(msg, action.outlet));
    yield put(showNotification(
      `Failed to add outlet ${action.outlet.name} `,
      msg,
      'error',
      10
    ));
  }
}

function *updateOutlet (action) {
  try {
    const { users, ...outlet } = action.outlet;
    yield call(OutletsAPI.updateOutlet, outlet);
    yield put(updateOutletSuccess(action.outlet));
    yield put(showNotification(
      'Success', `${action.outlet.name} saved`, 'info', 5
    ));
  } catch (error) {
    const msg = parseApiError(error);
    yield put(updateOutletFail(msg, action.outlet));
    yield put(showNotification(
      `Failed to update outlet ${action.outlet.name}`,
      msg,
      'error',
      10
    ));
  }
}

function *deleteOutlet (action) {
  try {
    yield call(OutletsAPI.deleteOutlet, action.outlet);
    yield put(deleteOutletSuccess(action.outlet));
    yield put(showNotification(
      'Success', `${action.outlet.name} deleted`, 'info', 5
    ));
  } catch (error) {
    const msg = parseApiError(error);
    yield put(deleteOutletFail(msg, action.outlet));
    yield put(showNotification(
      `Failed to delete outlet ${action.outlet.name}`,
      msg,
      'error',
      10
    ));
  }
}

function *outletSagas () {
  yield takeLatest(OUTLETS_FETCH_ALL, fetchOutlets);
  yield takeEvery(OUTLETS_ADD, addOutlet);
  yield takeEvery(OUTLETS_UPDATE, updateOutlet);
  yield takeEvery(OUTLETS_DELETE, deleteOutlet);
}

export default outletSagas;
